const news1 = `## Timer & One Rep Max Tools Available!
**2025-06-20**

We've just added two new tools to help trainers and clients get more from their workouts:

- The Timer Tool (see it under "Extra Tools" on the sidebar) makes it easy to time rest periods, helping you stay consistent and focused during training.
- The One Rep Max Calculator (see it under "Extra Tools" on the sidebar) lets you estimate your maximum strength for any lift, and provides multi-rep estimates for smarter programming.

These tools are designed to support effective, evidence-based training and make your sessions more productive!
`;



export default news1;
